import type { ReactNode } from 'react';

import type { LucideIcon } from 'lucide-react';

/**
 * Shared status banner layout for HITL/approval cards (icon + message pill). Callers pass the
 * tone-resolved `className` so each surface keeps its own palette (theme tokens vs a tenant brand).
 */
export function StatusAlert({
  icon: Icon,
  className,
  children,
}: {
  icon: LucideIcon;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium ${className ?? ''}`}
    >
      <Icon className="size-4 shrink-0" aria-hidden />
      <span>{children}</span>
    </div>
  );
}
